import { useState, useEffect } from "react";

export function useBottomShadow(scrollBoxRef: any, allPointsListData: any) {
  const [reachBottom, setReachBottom] = useState(false);

  useEffect(() => {
    console.log(scrollBoxRef.current);
    if (!scrollBoxRef.current) {
      return;
    }
    const { scrollHeight, clientHeight } = scrollBoxRef.current;
    console.log(scrollHeight, clientHeight);
    setReachBottom(scrollHeight === clientHeight);
  }, [allPointsListData, scrollBoxRef]);

  function handleScrollBottom(event: any) {
    const scrollBox = event.target;
    setReachBottom(
      scrollBox.scrollTop + scrollBox.clientHeight === scrollBox.scrollHeight
    );
  }

  return {
    handleScrollBottom,
    reachBottom,
  };
}
